import { ReportData } from '../types/reportTypes';

// Cody Cline Direct Sales March 2026 Data
// IMPORTANT: Using 13% flat OH calculation (Contract Total × 0.13)
// Source CSV: sample csv/2025 TLLG Marketing Leads Report - Cody - Sales Mar26.csv
// 13 valid jobs; trailing blank rows (rows 20-37) and Totals row (38) excluded per processing rules.
const jobData = [
  {
    jobInfo: "E-944: William Loehr",
    leadSource: "Referral- Cody's network",
    trade: "Roofing",
    contractTotal: 13682.00,
    grossMarginPct: 0.3824,
    grossProfit: 5232.00,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 13682.00 * 0.13,
    netProfit: 0
  },
  {
    jobInfo: "E-905: Carrie Swann",
    leadSource: "Referral- Cody's network",
    trade: "Roofing",
    contractTotal: 13640.00,
    grossMarginPct: 0.4932,
    grossProfit: 6727.25,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 13640.00 * 0.13,
    netProfit: 0
  },
  {
    jobInfo: "E-939: Aion Management Metro Pointe",
    leadSource: "Referral- Dominic's network",
    trade: "Roofing",
    contractTotal: 75000.00,
    grossMarginPct: 0.5426,
    grossProfit: 40695.00,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 75000.00 * 0.13,
    netProfit: 0
  },
  {
    jobInfo: "E-911: Matthew Hartley",
    leadSource: "Referral- Cody's network",
    trade: "Siding",
    contractTotal: 11875.00,
    grossMarginPct: 0.3458,
    grossProfit: 4106.38,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 11875.00 * 0.13,
    netProfit: 0
  },
  {
    jobInfo: "E-943: Paul Whitney",
    leadSource: "Referral- Cody's network",
    trade: "Roofing",
    contractTotal: 12988.00,
    grossMarginPct: 0.3823,
    grossProfit: 4965.31,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 12988.00 * 0.13,
    netProfit: 0
  },
  {
    jobInfo: "E-901: Liel Zinl",
    leadSource: "Referral- Dominic's network",
    trade: "Roofing",
    contractTotal: 13750.00,
    grossMarginPct: 0.3341,
    grossProfit: 4593.88,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 13750.00 * 0.13,
    netProfit: 0
  },
  {
    jobInfo: "E-946: North Green Condominium Association",
    leadSource: "Referral- Dominic's network",
    trade: "Siding",
    contractTotal: 1599.00,
    grossMarginPct: 0.6873,
    grossProfit: 1098.99,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 1599.00 * 0.13,
    netProfit: 0
  },
  {
    jobInfo: "E-916: The Enclave At Ellicott Hills",
    leadSource: "Referral- Dominic's network",
    trade: "Roofing",
    contractTotal: 5000.00,
    grossMarginPct: 0.5575,
    grossProfit: 2787.50,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 5000.00 * 0.13,
    netProfit: 0
  },
  {
    jobInfo: "E-908: Tabor Design Build",
    leadSource: "Referral- Cody's network",
    trade: "Roofing",
    contractTotal: 453.00,
    grossMarginPct: 0.3000,
    grossProfit: 135.90,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 453.00 * 0.13,
    netProfit: 0
  },
  {
    jobInfo: "E-918: Carolyn Bublitz",
    leadSource: "Referral- Cody's network",
    trade: "Siding",
    contractTotal: 29904.00,
    grossMarginPct: 0.5288,
    grossProfit: 15813.24,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 29904.00 * 0.13,
    netProfit: 0
  },
  {
    jobInfo: "E-912: Matt Oppenheim",
    leadSource: "Referral- Cody's network",
    trade: "Roofing",
    contractTotal: 625.00,
    grossMarginPct: 0.5200,
    grossProfit: 325.00,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 625.00 * 0.13,
    netProfit: 0
  },
  {
    jobInfo: "E-920: Kingsgate A Condominium",
    leadSource: "Referral- Dominic's network",
    trade: "Roofing",
    contractTotal: 69075.00,
    grossMarginPct: 0.7818,
    grossProfit: 54002.84,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 69075.00 * 0.13,
    netProfit: 0
  },
  {
    jobInfo: "E-929: Siman Builds Cohen Residence",
    leadSource: "Referral- Dominic's network",
    trade: "Windows & Doors",
    contractTotal: 8472.75,
    grossMarginPct: 0.4381,
    grossProfit: 3711.91,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 8472.75 * 0.13,
    netProfit: 0
  }
];

// Apply Cody Cline calculation formula
// Net Profit = Gross Profit - Company OH
// Sales Commission = Net Profit ÷ 2 (50% of Net Profit)
jobData.forEach(job => {
  job.netProfit = job.grossProfit - job.companyOH;
  job.salesCommission = job.netProfit / 2;
});

// Calculate totals
const totalContractValue = jobData.reduce((sum, job) => sum + job.contractTotal, 0);
const totalGrossProfit = jobData.reduce((sum, job) => sum + job.grossProfit, 0);
const totalCompanyOH = jobData.reduce((sum, job) => sum + job.companyOH, 0);
const totalNetProfit = jobData.reduce((sum, job) => sum + job.netProfit, 0);
const totalSalesCommissions = jobData.reduce((sum, job) => sum + job.salesCommission, 0);

// Aggregate sales by source
const salesBySourceMap = jobData.reduce((acc, job) => {
  const source = job.leadSource;
  if (!acc[source]) {
    acc[source] = {
      source,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[source].totalSales += job.contractTotal;
  acc[source].count += 1;
  acc[source].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { source: string; totalSales: number; count: number; grossProfit: number }>);

const salesBySource = Object.values(salesBySourceMap);

// Aggregate sales by trade
const salesByTradeMap = jobData.reduce((acc, job) => {
  const trade = job.trade;
  if (!acc[trade]) {
    acc[trade] = {
      trade,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[trade].totalSales += job.contractTotal;
  acc[trade].count += 1;
  acc[trade].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { trade: string; totalSales: number; count: number; grossProfit: number }>);

const salesByTrade = Object.values(salesByTradeMap);

export const codySalesMarch2026Data: ReportData = {
  kpis: {
    adSpend: 0,
    totalSales: totalContractValue,
    grossProfit: totalGrossProfit,
    salesCommissions: totalSalesCommissions,
    managerFees: 0,
    companyOH: totalCompanyOH,
    netProfit: totalNetProfit,
    netProfitPercent: totalNetProfit / totalContractValue,
    grossProfitPercent: totalGrossProfit / totalContractValue
  },

  adSpendBySource: [
    { source: "Referral- Cody's network", spend: 0 },
    { source: "Referral- Dominic's network", spend: 0 }
  ],

  salesBySource: salesBySource,

  salesByTrade: salesByTrade,

  jobData: jobData,

  period: {
    month: 3,
    year: 2026
  }
};
